import React from 'react';
import PropTypes from 'prop-types';
import { createChainedFunction } from '@atc/create-chained-function';
import Button from '../Button/index.js';

/**
 *  Creates a link-like object for Partners
 */
function PartnerLink(_ref) {
  let {
    children,
    className,
    href,
    inverse,
    label,
    onClick = () => {},
    undecorated,
    ...rest
  } = _ref;
  // handle any existing usages that may pass deprecated partner attribute from Link or LinkIcon
  delete rest.partner;
  delete rest.bsStyle;
  let style = undecorated ? 'text' : 'text-decorated';
  if (inverse) style = `${style}-inverse`;
  const redirect = () => window.open(href);
  const handleOnClick = createChainedFunction(onClick, redirect);
  return /*#__PURE__*/React.createElement(Button, Object.assign({
    bsStyle: style,
    "data-cmp": "partner-link",
    onClick: handleOnClick,
    className: className
  }, rest), label || children);
}
export default PartnerLink;